<div
    class="w-full relative bottom-2 mr-6 bg-white rounded-lg shadow-md overflow-hidden border border-gray-200 px-8 pt-6 pb-8">
    <div class="flex flex-col gap-6">
        <div class="text-dimot-1 text-[0.88em]">
            <h5>Non sono presenti farmaci in questa sezione.</h5>
        </div>
        <div>
            <h1 class="text-dimot-1 text-[1.5em]">Perché questa sezione?</h1>
            <div class="text-dimot-1 text-[0.88em] mt-2">
                <h5>Dopo il lancio, un farmaco richiede un monitoraggio continuo. Questa sezione ti consente di seguire
                    l'accesso sul territorio e agire tempestivamente in caso di variazioni a livello regionale o
                    ospedaliero.</h5>
                <h5 class="mt-2">Con questa sezione puoi mantenere l'accesso dei farmaci attivo, costante e tracciato.
                    Ogni
                    variazione diventa gestibile in modo strategico e operativo.</h5>
            </div>
        </div>

        <div>
            <h1 class="text-dimot-1 text-[1.2em]">Cosa puoi fare?</h1>
            <div class="text-dimot-1 text-[0.88em] mt-3">
                <ul class="flex flex-col gap-3">
                    <li>
                        <h2 class="inline ">Controllo totale sul territorio:&nbsp;</h2>
                        <h5 class="inline"> monitora l&#39;accessibilità per ogni ospedale o regione.</h5>
                    </li>
                    <li>
                        <h2 class="inline">Azioni rapide e mirate:&nbsp;</h2>
                        <h5 class="inline"> intervieni subito con attività tracciabili e coordinate.</h5>
                    </li>
                    <li>
                        <h2 class="inline">Trend e performance:&nbsp;</h2>
                        <h5 class="inline"> analizza l’andamento dell’accesso nel tempo con viste dinamiche.</h5>
                    </li>
                </ul>
            </div>
        </div>

        <div class="text-dimot-1 text-[0.95em] mb-8 mt-2">
            <h5>Contattaci per saperne di più!</h5>
        </div>

    </div>
    <button type="button"
        class="w-[106px] h-[38px] text-[0.9em] border-1 border-dimot-1 bg-dimot-1 text-white hover:bg-white hover:text-dimot-1 rounded-lg text-center cursor-pointer"
        data-cal-link="dimotma/30min" data-cal-namespace="30min" data-cal-config='{"layout":"month_view"}'>
        Contattaci
    </button>

</div>